import { computed, inject, Injectable } from '@angular/core';
import { AuthStore } from '@domains/auth/auth.store';
import { RoleStore } from '@domains/role/role.store';

/**
 * Answers "may the current user do X?" for `right_management` permission keys
 * (e.g. `admin_users_create`). Components wrap calls in a `computed()` so the
 * check re-evaluates when the rights finish loading.
 */
@Injectable({ providedIn: 'root' })
export class PermissionManagementService {
  private readonly authStore = inject(AuthStore);
  private readonly roleStore = inject(RoleStore);

  readonly isOwner = computed(() => this.authStore.currentUser()?.role.is_owner ?? false);
  readonly isAgentRole = computed(() => this.authStore.currentUser()?.role.is_agent_role ?? false);
  readonly isLoading = computed(() => this.roleStore.currentUserPermissionsLoading());

  can(key: string): boolean {
    return this.roleStore.currentUserPermissions()[key] ?? false;
  }
}
